import { render } from "./AddPanel.vue?vue&type=template&id=2cd230f4"
import script from "./AddPanel.vue?vue&type=script&lang=js"
export * from "./AddPanel.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__